import React from "react";
import { Button } from "@mui/material";
import { darkColors } from "../../theme/colors";

const GradientButton = ({
  text,
  onClick,
  width = "auto",
  variant = "contained",
  py = 1.45,
  fontSize = "16px",
  fontVariant = "bold",
  ml = 0,
  disabled = false,
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={{
        background: disabled
          ? "#A0A0A0" // Muted gray for disabled state
          : variant === "outlined"
          ? "transparent"
          : "linear-gradient(to bottom, #FD8804, #8E5009)",
        color: disabled
          ? "#FFFFFF" // Light text color for disabled state
          : variant === "outlined"
          ? darkColors.primary
          : darkColors.buttonText,
        fontSize: fontSize,
        // fontSize: `clamp(14px, 1vw, ${fontSize})`,
        fontWeight: fontVariant === "bold" ? 700 : 700, // Adjust font weight
        fontFamily: fontVariant === "bold" ? "MontserratBold" : "Montserrat", // Toggle font family
        borderRadius: 99,
        textTransform: "none",
        px: 4,
        ml: ml,
        py: py,
        width: width, // Apply the width from props
        border: variant === "outlined" ? "2px solid" : "none",
        borderColor: disabled
          ? "#A0A0A0" // Gray border for disabled outlined variant
          : variant === "outlined"
          ? darkColors.orange
          : "none",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        opacity: disabled ? 0.7 : 1, // Slight opacity for disabled state
      }}
    >
      {text}
    </Button>
  );
};

export default GradientButton;
